import checkMatch from './Functions/checkMatch';
import getParents from './Functions/getParents';

class State {
    constructor({ namespace, header, setActiveClassToCurrent }) {
        if (!namespace || !header) {
            return;
        }
        this.header = document.querySelector(header);

        this.listClass = `${namespace}__list`;
        this.itemClass = `${namespace}__item`;
        this.linkClass = `${namespace}__link`;

        this.activeState = '--active';
        this.currentState = '--current';

        this.setActiveClassToCurrent = setActiveClassToCurrent === undefined ? true : setActiveClassToCurrent;

        this.rootList = this.header.querySelector(`.${this.listClass}`);

        if (this.header && this.rootList) {
            this.setClasses();
        }
    }
    
    querySelector(path) {
        return this.rootList.querySelector(`a[href^="/"][href$="${path}"]`);
    }

    setClasses() {
        // set active states to links and items
        let path = window.location.pathname;

        // Try to get the current link
        let currentLink = this.querySelector(path);

        // If no link found, move the path up as long we have a path
        if (!currentLink) {
            while (!currentLink && path) {
                path = path
                    .split('/')
                    .slice(0, -1)
                    .join('/');
                currentLink = this.querySelector(path);
            }
        }

        // We have still no current link, so finish here
        if (!currentLink) {
            return;
        }

        // Set classes to link
        if (this.setActiveClassToCurrent) {
            currentLink.classList.add(this.linkClass + this.activeState);
        }
        currentLink.classList.add(this.linkClass + this.currentState);

        // Set class to item
        let currentItem = currentLink.parentNode;
        if (checkMatch(currentItem, `.${this.itemClass}`)) {
            if (this.setActiveClassToCurrent) {
                currentItem.classList.add(this.itemClass + this.activeState);
            }
            currentItem.classList.add(this.itemClass + this.currentState);

            // Set active state also to parent items
            let parentItems = getParents(currentItem, `.${this.itemClass}`, this.header);
            parentItems.forEach(list => {
                list.classList.add(this.itemClass + this.activeState);
            });
        }

        // Set active state also to parent lists
        let parentLists = getParents(currentLink, `.${this.listClass}`, this.rootList, false);
        parentLists.forEach(list => {
            list.classList.add(this.listClass + this.activeState);
        });
    }
}

export default State;
